import { createStorefrontApiClient } from '@shopify/storefront-api-client';

const Storefront = createStorefrontApiClient({
  storeDomain: `https://${Shopify.shop}`,
  apiVersion: '2025-07',
  publicAccessToken: theme.integrations.storefront.accessToken,
});

export default Storefront;
